import { storeToRefs } from "pinia";

export const useLoadUser = () => {
	const { getUserByEmail, isLoggedIn, logOut } = useNorcePwa();
	const { getUser } = storeToRefs(userStore());
	const router = useRouter();
	const localePath = useLocalePath();

	const userHasSession = async () => {
		return await isLoggedIn();
	};
	const loadUser = async () => {
		if (getUser.value && !Object.keys(getUser.value).length) {
			if (!(await userHasSession())) {
				return router.push(localePath("/login"));
			}
			await getAndSetUser();
		}
	};
	const getUserByEmailIfHasSession = async () => {
		if (await userHasSession()) {
			try {
				await getAndSetUser();
			} catch (error) {
				if (isNorcePwaError(error)) {
					if (error.statusCode === ErrorStatusCode.UNAUTHORIZED) {
						await logOut();
					}
				}
			}
		}
	};

	const getAndSetUser = async () => {
		const user = await getUserByEmail();
		if (user) {
			userStore().setUser(user);
		}
	};
	return { loadUser, userHasSession, getUserByEmailIfHasSession };
};
